import { render, staticRenderFns } from "./r-trigger-currency.vue?vue&type=template&id=9b9d13da&scoped=true"
import script from "./r-trigger-currency.vue?vue&type=script&lang=js"
export * from "./r-trigger-currency.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-currency.vue?vue&type=style&index=0&id=9b9d13da&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9d13da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b9d13da')) {
      api.createRecord('9b9d13da', component.options)
    } else {
      api.reload('9b9d13da', component.options)
    }
    module.hot.accept("./r-trigger-currency.vue?vue&type=template&id=9b9d13da&scoped=true", function () {
      api.rerender('9b9d13da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-currency.vue"
export default component.exports